import axios from 'axios';
import Seller from '../entity/seller.entity';

export default class SellerService {
  static readonly PATH_URL = '/api/v1/sellers';

  public static getSellers(): Promise<Seller[]> {
    return axios.get(this.PATH_URL)
      .then((response: any) => Seller.ofList(response.data));
  }

  public static create(seller: Seller): Promise<Seller> {
    return axios
      .post(this.PATH_URL, seller)
      .then((response: any) => Seller.of(response.data));
  }
}
